<white-label-default-header></white-label-default-header>
<div class="m-auto min-h-[100vh]">
    <router-outlet></router-outlet>
</div>
<!--    <app-main></app-main>-->

<!--<app-mobile-navigation-subdomain></app-mobile-navigation-subdomain>-->
<white-label-default-footer></white-label-default-footer>

<app-feed-back></app-feed-back>
